interface DocumentStatusBadgeProps {
  status: string;
  size?: "sm" | "md";
}

export default function DocumentStatusBadge({ status, size = "sm" }: DocumentStatusBadgeProps) {
  const normalized = status.toLowerCase().trim();

  const config: Record<string, { bg: string; text: string; border: string; icon: string }> = {
    "rascunho": { bg: "bg-background-100", text: "text-foreground-500", border: "border-background-300", icon: "ri-draft-line" },
    "em revisão": { bg: "bg-caution-50", text: "text-caution-700", border: "border-caution-200", icon: "ri-search-line" },
    "validado": { bg: "bg-primary-50", text: "text-primary-700", border: "border-primary-200", icon: "ri-check-double-line" },
    "reprovado": { bg: "bg-danger-50", text: "text-danger-700", border: "border-danger-200", icon: "ri-close-circle-line" },
    "vencido": { bg: "bg-danger-50", text: "text-danger-700", border: "border-danger-200", icon: "ri-error-warning-line" },
    "substituído": { bg: "bg-secondary-50", text: "text-secondary-700", border: "border-secondary-200", icon: "ri-swap-line" },
    "arquivado": { bg: "bg-background-100", text: "text-foreground-500", border: "border-background-200", icon: "ri-archive-line" },
    "sem vínculo": { bg: "bg-warning-50", text: "text-warning-700", border: "border-warning-200", icon: "ri-link-unlink-m" },
    "válida": { bg: "bg-primary-50", text: "text-primary-700", border: "border-primary-200", icon: "ri-check-line" },
    "vencida": { bg: "bg-danger-50", text: "text-danger-700", border: "border-danger-200", icon: "ri-error-warning-line" },
  };

  const c = config[normalized] || { bg: "bg-background-100", text: "text-foreground-500", border: "border-background-200", icon: "ri-question-line" };
  const sizeClass = size === "md" ? "px-2.5 py-1.5 text-sm" : "px-2 py-1 text-xs";

  return (
    <span className={`inline-flex items-center gap-1 ${sizeClass} rounded-md font-medium border ${c.bg} ${c.text} ${c.border}`}>
      <i className={`${c.icon} w-3.5 h-3.5 flex items-center justify-center`} />
      <span className="whitespace-nowrap">{status}</span>
    </span>
  );
}